import { addCategoriesSchema } from '../schema/addCategoriesSchema'
import { getData } from '../assets/scripts/GeneralFunctions'
import { toast } from 'react-toastify'
import { errorList } from './stateList'

export const addCategoriesSubmitHandler = async (
  inputs,
  error,
  setError,
  customer_types,
  setCustomer_types,
  setShowModal,
  setIsSubmit
) => {
  setIsSubmit(true)

  try {
    const validatedInputs = await addCategoriesSchema.validate(inputs, { abortEarly: false })

    const apiResult = await getData(
      `admin/site-options/customer-types/create`,
      'post',
      validatedInputs,
      true,
      false
    )
    if (apiResult) {
      if (apiResult?.status === 200) {
        setCustomer_types([apiResult?.data?.customer_type, ...customer_types])
        setShowModal(false)
        toast.success('دسته بندی با موفقیت افزوده شد.')
      } else {
        setError(apiResult?.error)
      }
      setIsSubmit(false)
    }
  } catch (err) {
    setError({
      ...error,
      ...errorList(err),
    })
  } finally {
    setIsSubmit(false)
  }
}
